import React, { Component } from 'react';
import './TecladoVirtual.css';
class VirtualKeyboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isDragging: false,
          position: { x: 0, y: 0 },
        };
        this.keyboardRef = React.createRef();
      }
  handleButtonClick = (e,value) => {
    e.preventDefault();
    console.log(value);
    // Maneja el clic en un botón del teclado virtual
    // Llama a una función para actualizar el campo de entrada actual
    this.props.onButtonClick(value);
  };
  handleMouseDown = (e) => {
    e.preventDefault();
    this.setState({
      isDragging: true,
      startPosition: { x: e.clientX, y: e.clientY },
    });
  };

  handleMouseMove = (e) => {
    if (this.state.isDragging) {
      const { x, y } = this.state.position;
      const { clientX, clientY } = e;
      const deltaX = clientX - this.state.startPosition.x;
      const deltaY = clientY - this.state.startPosition.y;
      this.setState({
        position: { x: x + deltaX, y: y + deltaY },
        startPosition: { x: clientX, y: clientY },
      });
    }
  };

  handleMouseUp = () => {
    this.setState({
      isDragging: false,
    });
  };
  handleCloseClick = () => {
    // Llama a una función para cerrar o desmontar el teclado virtual
    this.props.onCloseKeyboard();
  };
  render() {
    const { isDragging, position } = this.state;
    const { onButtonClick } = this.props;
    // Define los botones del teclado virtual en español latinoamericano
    const keyboardButtons = [
      '1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
      'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
      'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ñ',
      'Z', 'X', 'C', 'V', 'B', 'N', 'M', ',', '.', ' ',
      '<--',
    ];
  
    return (
      <div className="virtual-keyboard"
      ref={this.keyboardRef}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          cursor: isDragging ? 'grabbing' : 'grab',
        }}
        onMouseDown={this.handleMouseDown}
        onMouseMove={this.handleMouseMove}
        onMouseUp={this.handleMouseUp}>
        {keyboardButtons.map((button, index) => (
          <button
            key={index}
            onClick={(e) => this.handleButtonClick(e, button)}
            className={`keyboard-button ${button === '<--' ? 'backspace-button' : ''}`}
          >
            {button}
          </button>
        ))}
      </div>
    );
  }
}
export default VirtualKeyboard;
